import { USER_ROLES } from '@features/auth/utils/constants.ts';
import { ValueOf, DataStatuses } from '@shared/types/common';

export const ONBOARDING_STATE = {
  BILLING_INFO_NOT_FILLED: 'BILLING_INFO_NOT_FILLED',
  BILLING_INFO_IN_APPROVAL: 'BILLING_INFO_IN_APPROVAL',
  ADVERTISERS_NOT_ADDED: 'ADVERTISERS_NOT_ADDED',
  ADVERTISERS_IN_APPROVAL: 'ADVERTISERS_IN_APPROVAL',
  COMPLETED: 'COMPLETED',
};

export type BillingInfoDataStatus = ValueOf<typeof DataStatuses>;
export type ExternalUserTypeValue = typeof USER_ROLES.EXTERNAL_DIRECT_CLIENT | typeof USER_ROLES.EXTERNAL_AGENCY;
export type PossibleOnboardingState = ValueOf<typeof ONBOARDING_STATE>;
